import { render, staticRenderFns } from "./EnterpriseConnectionRequests.vue?vue&type=template&id=2b82f50a&scoped=true"
import script from "./EnterpriseConnectionRequests.vue?vue&type=script&lang=js"
export * from "./EnterpriseConnectionRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b82f50a",
  null
  
)

export default component.exports